export const jaDictionary = {
    lineup: "ラインナップ",
    catchphrase: "お気に入りのアイテムが見つかる",
    guide: {
        title: "ご購入の前に",
        subtitle: "事前にチェック",
        what_is_service: "Web ROLLとは？",
        delivery: "配送について",
        qa: "よくある質問",
        contact: "お問い合わせ",
        guide_to_signup: "初めての方はこちら",
        login: "ログイン",
        signup: "無料会員登録",
        link_login: "ログインはこちら",
        link_signup: "新規会員登録はこちら",
        login_sns: "SNSでカンタンログイン",
        signup_sns: "SNSでカンタン登録",
        email_login: "メールアドレスでログイン",
        email_signup: "メールアドレスで会員登録",
        google_login_support: "Googleログインができないお客様へ",
        login_form: {
            email: "メールアドレス",
            password: "パスワード",
            login_button: "Eメールでログイン",
            signup_button: "Eメールで会員登録",
            agree: "に同意する",
            forgot_password: "パスワードをお忘れの場合"
        },
        login_alert: {
            title: "会員登録すると\nWeb ROLLを\nご利用いただけます",
            description: "SNSでカンタン登録できます",
            login_button: "ログイン",
            signup_button: "無料会員登録"
        }
    },
    gacha: {
        selling_status: {
            ended: "販売終了しました",
            selling: {
                day: "あと{{value}}日",
                hour: "あと{{value}}時間",
                minute: "あと{{value}}分",
                absolute: "( ~{{date}} 販売終了予定 )"
            },
            comingsoon: {
                day: "販売開始まであと{{value}}日",
                hour: "販売開始まであと{{value}}時間",
                minute: "販売開始まであと{{value}}分",
                absolute: "( {{date}} 開始予定 )"
            }
        },
        play_limit: {
            reached_play_limit: "本日の購入上限に達しています",
            remaining_play_limit: "本日の購入可能回数: {{value}}回"
        },
        description: {
            more: "もっと見る",
            close: "閉じる"
        }
    },
    gift_code: {
        input: {
            title: "ギフトコード入力",
            cancel: "キャンセル",
            scan_qr: "QRコードを読み取る",
            submit: "アカウントに追加",
            code_placeholder: "ここへギフトコード番号を入力",
            require_code_error: "ギフトコードを入力してください",
            or: "または"
        }
    },
    global: {
        header: {
            history: "購入履歴",
            menu: "メニュー",
            signup_or_login: "無料会員登録・ログイン",
            menus: {
                mypage: "マイページ",
                logout: "ログアウト",
                login: "ログイン",
                signup: "無料会員登録",
                acquired_items: "獲得アイテム",
                input_code: "コード入力",
                gift_code: "ギフトコード",
                play_ticket: "無料チケット",
                prize_ticket: "チケット・クーポン",
                user_id: "ユーザーID : {{id}}"
            }
        },
        footer: {
            company: "会社概要",
            privacy: "プライバシーポリシー",
            terms: "利用規約",
            contact: "お問い合わせ",
            specified_commercial_transactions: "特定商取引法に基づく表記"
        },
        login: {
            status: {
                google: "Googleアカウントでログイン中",
                apple: "Appleアカウントでログイン中",
                password: "メールアドレスでログイン中",
                unknown: "ログイン情報なし"
            },
            success: "ログインに成功しました",
            error: {
                title: "ログインに失敗しました",
                description: "解決しない場合は別の認証方法をご利用ください"
            }
        },
        signup: {
            error: {
                title: "新規登録に失敗しました",
                description: "解決しない場合は別の認証方法をご利用ください"
            }
        },
        common: {
            tax: {
                included: "税込",
                excluded: "税抜"
            },
            piece: "回",
            sum: "合計",
            delivery_fee: "配送料",
            prize_unit: "個",
            remain_delivery_count: "あと{{bundle_amount}}個まで送料無料です",
            jst_date_warning: "記載されている時間は日本標準時刻(JST)です",
            ok: "OK",
            cancel: "キャンセル",
            register: "登録",
            submit: "送信",
            company: "会社概要",
            privacy: "プライバシーポリシー",
            terms: "利用規約",
            contact: "お問い合わせ",
            specified_commercial_transactions: "特定商取引法に基づく表記",
            payment_method: {
                credit: "クレジットカード",
                play_ticket: "無料チケット",
                paypay: "PayPay",
                carriers_au: "auかんたん決済",
                carriers_docomo: "d払い",
                carriers_softbank: "ソフトバンクまとめて支払い・ワイモバイルまとめて支払い",
                unionpay: "UnionPay(銀聯)",
                alipay_plus: "AliPay+",
                applepay: "Apple Pay",
                googlepay: "Google Pay",
            }
        },
        adult_contents: {
            question_of_adulthood: {
                title: "あなたは18歳以上ですか?",
                description: "一般的な作品に加えて、暴力・性描写など18歳未満の方は閲覧できない情報が含まれています。"
            },
            contents_switch: {
                general: "一般向け",
                adult: "成人向け(R-18)"
            }
        }
    },
    components: {
        view_registered_address: "登録した配送先を確認",
        shipping_forms: {
            country: "配送先の国",
            name: "氏名",
            phone: "電話番号",
            zip_code: "郵便番号",
            email: "メールアドレス",
            full_address: "住所",
            prefecture: "都道府県",
            city: "市区町村",
            address1: "丁目、番地",
            address2: "アパート・マンション・部屋番号",
            auto_fill: "住所検索",
            errors: {
                is_required: "必須項目です",
                address_auto_fill_not_in_service: "住所検索は日本の郵便番号にのみ対応しています",
                is_invalid_phone_number: "正しい電話番号を入力してください",
                is_invalid_email: "正しいメールアドレスを入力してください",
                is_zip_code_out_of_range: "3~9桁の範囲で入力してください"
            }
        },
        shipments: {
            title: "配送先",
            about_bundle_capacity: "商品【{{amount}}個】ごとに",
            about_fee: "配送料について",
            about_fee_detail: "▼送料についての詳細",
            period: "▼配送目安"
        },
        order_info: {
            play_ticket: "無料チケット:",
            order_date: "注文日時:",
            play_amount: {
                single: "{{amount}}回くじ",
                multi: "{{amount}}連くじ"
            },
            payment_method: {
                label: "決済方法:",
                no_info: "決済情報なし"
            },
            delivery: {
                title: {
                    delivery: "配送ステータス:",
                    local_pickup: "受け取りステータス:"
                },
                status: {
                    not_shipped: "未発送",
                    shipped: "発送済み",
                    not_picked: "未受け取り",
                    picked: "受け取り済み",
                    no_delivery: "配送しない設定の注文です"
                }
            }
        },
        play_ticket: {
            has_amount: "{{amount}}枚所持",
            infinite_expire: "期限なし",
            expire: "有効期限: {{date}}",
            play_amount: "回数: {{amount}}",
            guide_to_register_play_ticket: "ギフトコードをお持ちの場合はこちら"
        }
    },
    pages: {
        gacha: {
            prizes: {
                about: "商品について",
                lineup: "商品一覧",
                view_collection: "獲得したアイテムを見る"
            },
            purchase_benefits: "購入特典",
            collection_items: "獲得した商品",
            collection: "コレクション",
            "ticket/coupon": "チケット・クーポン",
            guide_to_collection: "当選したデジタルコンテンツ・チケット・クーポンは「獲得した商品」から確認できます",
            delivery: {
                price: "配送料",
                detail: "配送料について"
            },
            play: {
                single: "{{amount}}回くじ",
                multi: "{{amount}}連くじ",
                single_lottery: "{{amount}}回くじを引く",
                multi_lottery: "{{amount}}連くじを引く",
                button: "購入する",
                view_play_buttons: "このガチャを購入する",
                has_play_ticket: "無料チケットが使えます"
            },
            unplayable: {
                comingsoon: "準備中です",
                discontinued: "販売終了しました",
                soldout: "売り切れ中です",
                closing: "販売停止中です"
            },
            result: {
                title: "くじ結果"
            }
        },
        onepass: {
            invalid_format: "正しい形式で入力してください",
            please_enter: "コードを入力して下さい",
            please_login: "ログインしてください",
            send_error: "送信に失敗しました"
        },
        local_pickup: {
            qr_code_title: "この画面をスタッフに提示してください",
            qr_code_description: "未受け取りの商品を確認しお渡し致します。",
            display_qr_code: "受取用のQRコードを表示します",
            open_qr_code_modal: "受取QRコードを表示",
            pickup_code: "コード：",
            user_reference_number: "あなたの整理番号：",
            calling_reference_number: "呼び出し中の整理番号：",
            pickup_location: "受け取り場所：",
            pickup_location_detail: "受け取り場所の詳細情報",
            enter_prize_pickup: "商品の受け取りに進む",
            local_pickup_description: "このガチャは会場受け取りガチャです",
            pickup_item_count: "{{count}}個の商品"
        },
        check_in: {
            title: "チェックイン",
            modal: {
                title: "このガチャは来場者限定です",
                description: "会場に到着したら「チェックイン」をタップして会場到着の判定を行なってください",
                check_in_progress_1: "会場の近くにいるか、",
                check_in_progress_2: "チェック中..."
            },
            result: {
                success: "チェックインに成功しました",
                not_nearby: {
                    title: "チェックインに失敗しました",
                    description: "会場付近で再度お試しください"
                },
                permission_denied: {
                    title: "位置情報の取得が許可されていません",
                    ios_description: "ブラウザの設定-> Webサイトの設定 -> 位置情報 から許可を選択して再度実行してください",
                    android_description: "設定アプリを起動して、アプリと通知 -> アプリと通知の詳細設定 -> アプリの権限 -> 位置情報Chromeの位置情報をONにしてページをリロードした後、もう一度お試しください"
                },
                get_location_failed: {
                    title: "位置情報の取得に失敗しました",
                    description: "再度お試しください"
                }
            }
        },
        prize_ticket: {
            no_available_ticket: "利用可能なチケット・クーポンはありません",
            used_ticket: "使用済みのチケット・クーポン一覧"
        },
        my_page: {
            title: "アカウント",
            nickname: {
                edit: "ニックネームを編集する",
                register: "ニックネームを登録する"
            },
            user_id: "ユーザーID",
            shipping_info: {
                title: "配送先情報",
                register: "配送先情報を登録する",
                edit: "配送先情報を編集する"
            },
            delete_account: {
                title: "退会する",
                modal: {
                    title: "本当に退会しますか?",
                    description: "退会すると、登録済みの個人情報・購入履歴など全ての情報が削除され、 購入済みのデジタルコンテンツへのアクセスや、ダウンロードはできなくなります。 配送前の商品については通常通り発送されます。",
                    agree: "同意する",
                    confirm: "退会する",
                    cancel: "キャンセル",
                    success: {
                        title: "退会に成功しました",
                        description: "ご利用ありがとうございました"
                    },
                    error: {
                        title: "退会処理に失敗しました。",
                        description: "ログインしなおした上で再度お試しください。"
                    }
                }
            }
        },
        buy: {
            title: "お届け先情報入力",
            submit_title: "購入する",
            buy_again: "もう一度購入する",
            return_to_top: "TOPへ戻る",
            cancel: "キャンセルする",
            check_warning: {
                title: "注意事項",
                form_title: "注意事項を確認しました"
            },
            shippings: {
                title: "配送先情報",
                different_address_warning: "配送先情報を変更すると、配送料がかかります",
                cannot_ship_warning: "選択されたガチャはお客様のアカウントに登録されている住所にお届けすることができません。配送可能な住所を入力してください。",
                forms: {
                    country: "配送先の国",
                    name: "氏名"
                },
                no: {
                    title: "当選した商品を配送しない",
                    description: "デジタルコンテンツのみ視聴できます。",
                    not_deliver_display_text: "当選した商品を配送しない",
                    warning: "当選した商品は発送されません。 ご注意ください。",
                    confirm_title: "当選した商品を配送しなくてもよろしいですか？",
                    confirm_description: "デジタルコンテンツのみ視聴が可能です。当選した商品を配送で受け取りたくない場合にご利用ください。"
                }
            },
            payments: {
                title: "支払い方法",
                methods: {
                    credit: "クレジットカード",
                    paypay: "PayPay",
                    carrier: "キャリア決済",
                    unionpay: "UnionPay"
                },
                credit: {
                    title: "クレジットカード情報",
                    cardno: "カード番号",
                    exp: "有効期限",
                    holder_name: "氏名",
                    security_code: "セキュリティコード",
                    what_is_security_code: "セキュリティコードとは",
                    quantity_full: "クレジットカードを新しく登録する際には、登録済みのクレジットカードを削除お願いします",
                    register_card: "クレジット情報を登録する",
                    supported_card_text: "以下のカード会社に対応しております"
                },
                carrier: {
                    title: "キャリア決済選択"
                },
                purchase_detail_description: {
                    credit: "※カードの明細には「SWAMP STORE」と記載されます。\n「SWAMP STORE」はこちらの購入明細となります。",
                    app: "※アプリの明細には「SWAMP STORE」と記載されます。\n「SWAMP STORE」はこちらの購入明細となります。"
                }
            },
            tipping_message: {
                title: "販売者へメッセージを送る",
                placeholder: "メッセージを入力してください",
                invalid_length: "文字数が多すぎます",
                caution: "クリエイターの配信で利用される可能性があるので、不適切な内容は記入しないでください。"
            }
        },
        history: {
            title: "購入履歴",
            no_history: "購入履歴がありません",
            guide_to_collection: "当選したデジタルコンテンツは獲得した商品よりご覧いただけます",
            items_not_yet_received: "未受け取りの商品",
            order_detail: {
                title: "購入詳細"
            },
            play_amount: {
                single: "1回ガチャ",
                multi: "{{amount}}連ガチャ"
            }
        },
        play_ticket: {
            title: "持っている無料チケット"
        }
    },
    country: {
        JP: "日本",
        US: "アメリカ",
        CN: "中国",
        KR: "韓国",
        TW: "台湾",
        HK: "香港"
    },
    errors: {
        "404": {
            title: "指定されたURLのページが存在しません",
            description: "URLが間違っているか、ページが削除された可能性があります。解決しない場合は、アカウント > お問い合わせからお問い合わせください。"
        },
        "500": {
            title: "エラーが発生しました",
            description: "解決しない場合は、アカウント > お問い合わせからお問い合わせください。"
        },
        not_found: {
            title: "リクエストされたページは存在しません",
            description: "URLが間違っているか、ページが削除された可能性があります。解決しない場合は、アカウント > お問い合わせからお問い合わせください。"
        },
        failed: {
            check_in: "チェックインに失敗しました",
            get_gacha_detail: "イベント情報の取得に失敗しました",
            get_gacha_history: "購入履歴の取得に失敗しました"
        }
    }
};
